var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"who-are-we-comp"},[_c('component-title',{attrs:{"title":"Who are we?","subtitle":"JEECIST"}}),_vm._v(" "),_c('div',{staticClass:"who-are-we-text"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12f51b79","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Who_Are_We.vue
// module id = null
// module chunks = 